import _ from 'lodash';
import { FC, HTMLAttributes, ReactNode, useMemo } from 'react';

type TypographyAlign = 'left' | 'center' | 'right';
type TypographyVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body1' | 'body2';

interface TypographyProps {
  align?: TypographyAlign;
  className?: string;
  children?: ReactNode;
  hasError?: boolean;
  variant?: TypographyVariant;
  style?: HTMLAttributes<HTMLDivElement>['style'];
}

const Typography: FC<TypographyProps> = ({ align, children, className, hasError, style, variant = 'body1' }) => {
  const variantClass = useMemo(() => {
    switch (variant) {
      case 'h1':
        return 'cb-h1';
      case 'h2':
        return 'cb-h2';
      case 'h3':
        return 'cb-h3';
      case 'h4':
        return 'cb-h4';
      case 'h5':
        return 'cb-h5';
      case 'h6':
        return 'cb-h6';
      case 'body1':
        return 'cb-paragraph1-st';
      case 'body2':
        return 'cb-paragraph2-st';
      default:
        return '';
    }
  }, [variant]);

  const alignClass = useMemo(() => {
    if (!align) return '';
    return `cb-align-${align}`;
  }, [align]);

  const spanClass = [alignClass, variantClass, className, hasError ? 'cb-red1-color' : ''].filter(_.identity).join(' ');

  return (
    <div className={spanClass} style={style}>
      {children}
    </div>
  );
};

export default Typography;
